import { FC } from "react";
import { Stack, styled } from "@mui/material";
import { Outlet } from "react-router-dom";

export const PartnerLayout: FC = () => {
  return (
    <PartnerLayoutWrapper>
      <Outlet />
    </PartnerLayoutWrapper>
  );
};

const PartnerLayoutWrapper = styled(Stack)`
  width: 100%;
  max-width: 1198px;
  margin: 0 auto;
`;
